import React, { useState } from 'react';
import { Dropdown, DropdownMenu, DropdownToggle, Form } from 'reactstrap';

//import Components
import FullScreenDropdown from '@velzon/components/FullScreenDropdown.js';
import ProfileDropdown from '@velzon/components/ProfileDropdown.js';

const Header = ({ headerClass }) => {

  const [search, setSearch] = useState(false);
  const toggleSearch = () => {
    setSearch(!search);
  };

  return (
    <React.Fragment>
      <header id="page-topbar" className={headerClass}>
        <div className="layout-width">
          <div className="navbar-header">
            <div className="d-flex">
            </div>

            <div className="d-flex align-items-center">

              <Dropdown isOpen={search} toggle={toggleSearch} className="d-md-none topbar-head-dropdown header-item">
                <DropdownToggle type="button" tag="button" className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle">
                  <i className="bx bx-search fs-22"></i>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-lg dropdown-menu-end p-0">
                  <Form className="p-3">
                    <div className="form-group m-0">
                      <div className="input-group">
                        <input type="text" className="form-control" placeholder="Search ..."
                          aria-label="Recipient's username" />
                        <button className="btn btn-primary" type="submit"><i
                          className="mdi mdi-magnify"></i></button>
                      </div>
                    </div>
                  </Form>
                </DropdownMenu>
              </Dropdown>

              {/* FullScreenDropdown */}
              <FullScreenDropdown />

              {/* ProfileDropdown */}
              <ProfileDropdown />
            </div>
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

export default Header;